import { render, staticRenderFns } from "./giftIcon.vue?vue&type=template&id=faf0fde0&"
import script from "./giftIcon.vue?vue&type=script&lang=js&"
export * from "./giftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports